import '../../node_modules/@gouvfr/dsfr/dist/dsfr.module.min.js'

import "./TestPushActif.ts"
import "./WePush.ts"
import "./TestWebSocket.ts"
import "./WebSocketMessagerie.ts"

import "./GlobalInitialisation.ts"
import '../styles/main.scss'

import './CompteurNonLus.ts'

import './Profile.ts'

import './eline/efface_historique.ts'

console.log("starting script");